import { ref, computed } from "vue";
import { useToast } from "vue-toastification"

import store from "../state/store"


export default function useUsers(props, emit, userData) {

    // Get toast interface
    const toast = useToast()

    const userStatus = ref("")
    const search = ref("")
    const createdAtDate = ref("")
    const perPage = ref(10)
    const sortField = ref("updated_at")
    const sortDirection = ref("desc")
    const loading = ref(false)
    const errors = ref({})


    const show = computed({
        get: () => props.modelValue,
        set: (value) => emit("update:modelValue", value),
    })

    const getUsers = (url = null) => {
        store.dispatch("getUsers", {
            url,
            search: search.value,
            status: userStatus.value,
            created_at: createdAtDate.value,
            per_page: perPage.value,
            sort_field: sortField.value,
            sort_direction: sortDirection.value,
        })
    }

    const onSubmit = () => {
        loading.value = true
        if (userData.value.id) {
            store.dispatch('updateUser', userData.value)
                .then(response => {
                    loading.value = false;
                    if (response.status === 200) {
                        toast.success("کاربر با موفقیت به روز شد!", {
                            timeout: 3000,
                        })
                        store.dispatch("getUsers")
                        closeModal()
                    }
                })

        } else {
            store
                .dispatch("createUser", userData.value)
                .then((response) => {
                    loading.value = false
                    if (response.status === 201) {
                        console.log('Yes');
                        toast.success("کاربر مورد نظر با موفقیت اضافه شد!", {
                            timeout: 3000,
                        })
                        store.dispatch("getUsers")
                        closeModal()
                    }
                })
                .catch((err) => {
                    loading.value = false
                    errors.value = err.response.data.errors
                })
        }
    }

    const changePasswordUser = () => {
        loading.value = true
        if (userData.value.id) {
            store.dispatch('changePasswordUser', userData.value)
                .then(response => {
                    loading.value = false;
                    if (response.status === 200) {
                        toast.success("کلمه عبور کاربر مورد نظر با موفقیت به روزرسانی شد!", {
                            timeout: 3000,
                        })
                        store.dispatch("getUsers")
                        closeModal()
                    }
                })
                .catch((err) => {
                    loading.value = false
                    errors.value = err.response.data.errors
                })

        }
    }

    const closeModal = () => {
        show.value = false
        errors.value = {}
        emit("close")
    }


    return {
        show,
        userStatus,
        search,
        createdAtDate,
        perPage,
        sortField,
        sortDirection,
        loading,
        errors,
        getUsers,
        onSubmit,
        changePasswordUser,
        closeModal,
    }
}